module.exports = __webpack_public_path__ + "static/media/Maf_banners-familiar-.b38f3eae.jpg";